export default (data) => `
<a class="Autocompletions-item js-autocompletionItem ${data.active ? 'is-active' : ''}"
   href="${data.href}" 
   data-position="${data.index}" 
   id="${data.index}" 
   role="option" 
   ${data.active ? "aria-selected='true'" : ''}>
    <div class="u-allCaps Autocompletions-suggestionSource">${data.field}</div>
    <div class="Autocompletions-suggestion">${data.resultText}</div>
</a>
`;
